import { connect } from 'react-redux';
import {
  getPdfJob,
  getIsFetchCompleted,
  fetchPdfJobStatus
} from 'src/reducers/reports/notificationOfBaseAmountRevisionAsync';
import { INITIAL_POLLING_INTERVAL } from 'src/constants/Generals';
import PdfModalBase from '../components/PdfModalBase';

const mapStateToProps = (state, ownProps) => ({
  pdfJob: getPdfJob(state, ownProps.revisionYear),
  isFetchCompleted: getIsFetchCompleted(state)
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchPdfJobStatus: () => {
    dispatch(fetchPdfJobStatus(INITIAL_POLLING_INTERVAL, ownProps.revisionYear));
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(PdfModalBase);
